(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aw-aura-inicio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aw-aura-page')) {
  customElements.define('aw-aura-page', class extends HTMLElement {
    connectedCallback() {
      if (this._cleanup) this._cleanup();
      const controller = new AbortController();
      const signal = controller.signal;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let paused = false;
      const update = () => {
        const stopped = paused || reduced.matches || this.dataset.enabled !== 'true';
        this.dataset.motion = stopped ? 'paused' : 'playing';
        const button = this.querySelector('.aw-motion-control');
        if (button) {
          button.setAttribute('aria-pressed', String(paused));
          button.querySelector('.aw-motion-label').textContent = stopped ? button.dataset.play : button.dataset.pause;
          button.querySelector('.aw-motion-icon').textContent = stopped ? '▷' : 'Ⅱ';
        }
      };
      this.addEventListener('click', event => {
        if (event.target.closest('.aw-motion-control')) { paused = !paused; update(); }
      }, {signal});
      const visibility = () => { this.dataset.pageHidden = String(document.hidden); };
      document.addEventListener('visibilitychange', visibility, {signal});
      reduced.addEventListener('change', update, {signal});
      const frame = requestAnimationFrame(update);
      visibility();
      this._cleanup = () => { controller.abort(); cancelAnimationFrame(frame); };
    }
    disconnectedCallback() { if (this._cleanup) this._cleanup(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
